export const campaignStyles = {
  alert: {
    bgcolor: "#d32f2f",
    color: "#fff",
    borderRadius: "4px",
    px: 2,
    py: 1,
    wordWrap: "break-word",
    mb: 2,
    opacity: 0.8,
  },
  disableQueueBtn: {
    width: "75px",
    textDecoration: "none",
    textTransform: "none",
    color: "#FFFFFF !important",
    fontWeight: "600",
    fontSize: "13px",
    background: "#b20000",
    borderRadius: 0.5,
    py: "2px",

    "&:hover": {
      background: "#c0392b !important",
    },
  },
  clearQueueBtn: {
    width: "75px",
    textDecoration: "none",
    textTransform: "none",
    color: "#FFFFFF !important",
    fontWeight: "600",
    fontSize: "13px",
    background: "#615E59",
    borderRadius: 0.5,
    py: "2px",
    "&:hover": {
      background: "#3f3d3a !important",
    },
  },
  queueContainer: {
    position: "absolute",
    top: 90,
    right: 10,
    zIndex: 100,
    width: 320,
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#fff",
    opacity: 0.95,
    border: "1px solid rgb(177, 177, 177)",
  },
};
